import { useNavigate } from 'react-router-dom';
import { BindingUsersPage } from '@practium/features/users';
import type { BindingTab, BindingUsersPermissions } from '@practium/features/users';
import { usePermissions } from '@practium/features/permissions';
import { useForBinding } from '@practium/features/forBinding';
import { UserHierarchyLevel } from '@practium/shared';

export const UsersPageClient = () => {
	const navigate = useNavigate();
	const { bindingUsersPermissions } = usePermissions();
	const { isForBinding, forBindingUserLevel } = useForBinding();

	const isViewingConsultant = isForBinding && forBindingUserLevel === UserHierarchyLevel.Consultant;

	const effectivePermissions: BindingUsersPermissions = isViewingConsultant
		? {
				canCreate: false,
				canEdit: false,
				canDelete: false,
				canEnterProfile: true,
				canManageFarmers: true,
				canManageConsultants: false,
			}
		: bindingUsersPermissions;

	const handleAddNew = (tab: BindingTab) => {
		navigate(`/usuarios/novo?type=${tab}`);
	};

	const handleViewItem = (tab: BindingTab, id: string) => {
		navigate(`/usuarios/ver?type=${tab}&id=${id}`);
	};

	const handleEnterProfile = (tab: BindingTab, id: string) => {
		const bindingType = tab === 'farmers' ? 1 : 2;
		window.open(`/dashboard?forBinding=${id}&bindingType=${bindingType}`, '_blank');
	};

	return (
		<BindingUsersPage
			permissions={effectivePermissions}
			onAddNew={isViewingConsultant ? undefined : handleAddNew}
			onViewItem={handleViewItem}
			onEnterProfile={handleEnterProfile}
		/>
	);
};
